import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { UserInformation } from '@/app/api/morgan-thermal/user';

export const disableUser = createEndpoint<Informative>(({fetch}) => (id: UserInformation['id']) => fetch(`/User/Disable/${id}`, {method: 'POST'}));